// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-site-map-content-name-column-link .tag-name-wrapper.tag-level-1 {
  font-size: 16px;
  font-weight: 500;
}
.fi-site-map-content-name-column-link .tag-name-wrapper.tag-level-2 {
  font-size: 14px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./Source/app/site-map/site-map-content-name-column-link/site-map-content-name-column-link.component.scss"],"names":[],"mappings":"AAEQ;EACI,eAAA;EACA,gBAAA;AADZ;AAGQ;EACI,eAAA;EACA,gBAAA;AADZ","sourcesContent":[".fi-site-map-content-name-column-link {\r\n    .tag-name-wrapper {\r\n        &.tag-level-1 {\r\n            font-size: 16px;\r\n            font-weight: 500;\r\n        }\r\n        &.tag-level-2 {\r\n            font-size: 14px;\r\n            font-weight: 500;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
